import { render, staticRenderFns } from "./DataGraph.vue?vue&type=template&id=6b35b2db&scoped=true"
import script from "./DataGraph.vue?vue&type=script&lang=js"
export * from "./DataGraph.vue?vue&type=script&lang=js"
import style0 from "./DataGraph.vue?vue&type=style&index=0&id=6b35b2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35b2db",
  null
  
)

export default component.exports